export default "__VITE_ASSET__BXgGzQFM__"